module.exports = __webpack_public_path__ + "img/012-toaster.05eeb57b.svg";